<template>
  <div class="info-cards-container">
    <div class="info-card">
      <div class="info-card-content">
        <div class="info-icon yellow">
          <i class="fa-solid fa-sack-dollar"/>
        </div>
        <div class="info-text">
          <div class="info-label">충전금 잔액</div>
          <div class="info-value">{{ formatNumber(totalRemainAmt) }}원</div>
        </div>
      </div>
    </div>

    <div class="info-card">
      <div class="info-card-content">
        <div class="info-icon blue">
          <i class="fa-solid fa-truck fa-flip-horizontal"/>
        </div>
        <div class="info-text">
          <div class="info-label">배송 중</div>
          <div class="info-value">{{ totalDeliveryCount }}건</div>
        </div>
      </div>
    </div>

    <div class="info-card">
      <div class="info-card-content">
        <div class="info-icon green">
          <i class="fa-solid fa-check"/>
        </div>
        <div class="info-text">
          <div class="info-label">배송 완료</div>
          <div class="info-value">{{ totalCompletedCount }}건</div>
        </div>
      </div>
    </div>

    <div class="info-card">
      <div class="info-card-content">
        <div class="info-icon purple">
          <i class="fa-solid fa-user"/>
        </div>
        <div class="info-text">
          <div class="info-label">담당자</div>
          <div class="info-value">{{ empName || '-' }}</div>
          <div class="info-sub">{{ deptName || '-' }}</div>
          <div class="info-sub">{{ empMobile || '-' }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cardInfo: {
      type: Object,
      required: true
    }
  },
  computed: {
    totalRemainAmt() {
      return this.cardInfo.totalRemainAmt || 0;
    },
    totalDeliveryCount() {
      return this.cardInfo.totalDeliveryCount || 0;
    },
    totalCompletedCount() {
      return this.cardInfo.totalCompletedCount || 0;
    },
    empName() {
      return this.cardInfo.empName || '';
    },
    deptName() {
      return this.cardInfo.deptName || '';
    },
    empMobile() {
      return this.cardInfo.empMobile || '';
    }
  },
  methods: {
    formatNumber(value) {
      if (!value) return '0';
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  }
}
</script>

<style lang="scss" scoped>
.info-cards-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}

.info-card {
  background: #FFFFFF;
  border-radius: 14px;
  padding: 20px;
  box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.05);

  .info-card-content {
    display: flex;
    align-items: flex-start;
    gap: 16px;
  }

  .info-icon {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    i {
      font-size: 20px;
    }

    &.yellow {
      background-color: #FFF1B8;
      color: #F59B00;
    }

    &.blue {
      background-color: #D6EBFF;
      color: #3F98F3;
    }

    &.green {
      background-color: #DAF4CD;
      color: #1FAD1F;
    }

    &.purple {
      background-color: #d6ddff;
      color: rgb(120, 140, 237);
    }
  }

  .info-text {
    flex: 1;

    .info-label {
      font-size: 14px;
      color: #6E747C;
      margin-bottom: 4px;
    }

    .info-value {
      font-size: 20px;
      font-weight: 600;
      color: #2F3337;
      margin-bottom: 4px;
    }

    .info-sub {
      font-size: 14px;
      color: #8D939A;
      margin-bottom: 2px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

@media (max-width: 1200px) {
  .info-cards-container {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .info-cards-container {
    grid-template-columns: 1fr;
  }
}
</style> 